export const ICONS_OPTIONS = [
"public_buildings_apartment",
"public_symbols_video",
"public_objects_camera",
"public_objects_map",
"public_objects_microphone",
"public_symbols_bell",
"public_symbols_wifi",
"public_symbols_star",
"public_symbols_bookmark",
"public_symbols_clock",
"public_symbols_flag-alt",
"public_symbols_dollar-sign",
"public_symbols_check-circle",
"public_symbols_diamond",
"public_symbols_ban",
"public_symbols_heart",
"public_symbols_image",
"public_symbols_info-circle",
"public_symbols_lock",
"public_symbols_map-marker-alt",
"public_symbols_recycle",
"public_symbols_play",
"public_symbols_parking",
"public_symbols_moon",
"public_symbols_smoking-ban",
"public_symbols_trash-alt",
"public_buildings_toilet"
];